import { api } from './api';

export const sessionList = async () =>{  
  return await api.get('/sessions')
};

export const sessionAdd = async (data) =>{
  return await api.post('/session/add', data)
};

export const sessionUpdate = async (data) =>{
  return await api.post('/session/update', data)
};

export const sessionStatusChange = async (data) => {
  return await api.post(`/session/status/change` ,data);
};

export const sessionDelete = async (id)=>{
  return await api.post(`/session/delete`, {id})
}

